import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setToken } from '../slices/authSlice';
import useCookieWithListener from "./useCookie";

interface AuthError extends Error {
  error?: string;
}

const useAuth = () => {
  const { loginWithRedirect, getAccessTokenSilently, logout, isAuthenticated, isLoading } = useAuth0();
  const dispatch = useDispatch();
  const [ authCookieValue ] = useCookieWithListener(/^auth0\..*\.is\.authenticated$/);

  
  useEffect(() => {
    // user was authenticated, but signed out in another tab
    if (isAuthenticated && !authCookieValue) logout({ returnTo: window.location.origin });
  }, [ authCookieValue ]);

  useEffect(() => {
    const storeToken = async () => {
      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently({
            audience: process.env.REACT_APP_Auth0Audience,
            scope: 'read:users',
          });
          // console.log('useAuth --- token = ', token)
          dispatch(setToken(token));
        } catch (error) {
          const authError = error as AuthError;
          if (authError.error === 'consent_required') {
            console.log('CAUGHT ERROR: ', error);
            loginWithRedirect({
              audience: process.env.REACT_APP_Auth0Audience,
              scope: 'read:users',
            });
          } else {
            console.error('Error getting token', error);
          }
        }
      }
    };

    storeToken()

  }, [isAuthenticated, getAccessTokenSilently, dispatch]);

  return { loginWithRedirect, isLoading };
};

export default useAuth;